import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    CanLoad,
    Route,
    Router, RouterStateSnapshot
} from '@angular/router';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
    private readonly allowExternalRoutes = [
        '/',
        '/home',
        '/claims',
        '/access-denied'
    ];
    constructor(private readonly authService: AuthService, private readonly router: Router) {

    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const url: string = state.url;
        return this.checkLogin(url);
    }

    public canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    public canLoad(route: Route): boolean {
        const url = '/${route.path}';
        return this.checkLogin(url);
    }

    private checkLogin(url: string): boolean {
        if (this.authService.isLoggedIn) {
            if (!this.authService.isRoleValid() && !url.startsWith('/access-denied')) {
                this.router.navigate(['access-denied']);
                return false;
            }

            if (this.authService.isExternalUser() && !this.authService.isOperator()) {
                if (this.allowExternalRoutes.indexOf(url) <= 0 && !url.startsWith('/riskassessment')) {
                    this.router.navigate(['access-denied']);
                    return false;
                }
                return true;
            } else {
                return true;
            }
        }

        this.authService.setLastPageUrl(url);
        return false;
    }
}
